import Vue from 'vue';

const scrollBus = new Vue({})

export default scrollBus;


// WEBPACK FOOTER //
// ./src/components/scrollbar/ScrollBus.js